import React from "react";
// styles
import injectSheet from 'react-jss';
import styles from './space_styles';

const Space = injectSheet(styles)((props) => {
  return (
    <div className={`${props.classes.space} ${props.klass}`} style={props.style}>
      {props.children}
    </div>
  )
});

export default Space;